export const historyConfig = {
  root: "/",
};

export const SESSION_LIMIT_TIME = 60 * 60 * 24;
export const SESSION_ALERT_TIME = 60;
